module.exports = __webpack_public_path__ + "b5f0f64b2ee19f1ace66e5d1e67674ac.svg";